module.exports = __webpack_public_path__ + "static/media/auth-sidebar-vector.5cb75944.svg";